import { render, staticRenderFns } from "./SingleProps.vue?vue&type=template&id=0daaeac9&"
import script from "./SingleProps.vue?vue&type=script&lang=js&"
export * from "./SingleProps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports